module.exports = __webpack_public_path__ + "img/title.a4dd1a73.png";